import { PlannerEnv, envToBaseUrl } from '@/utils/env';
import Fetch from '../fetch/Fetch';
import { PlannerConfigEntity } from './PlannerConfigTypes';

export class Production {
  private baseUrl;

  constructor(env: PlannerEnv) {
    this.baseUrl = `${envToBaseUrl(env)}`;
  }

  public async getList(identifier?: string) {
    let url = `${this.baseUrl}/published/list?limit=100000`;

    if (identifier) {
      url += `&identifier=${identifier}`;
    }

    const response = await Fetch.json(url);
    //@ts-expect-error - response.data is not defined in Fetch.json
    return response.data as PlannerConfigEntity[];
  }

  public async getSinglePlanner(identifier?: string) {
    let url = `${this.baseUrl}/published/data/${identifier}`;

    const response = await Fetch.json(url);

    return response as PlannerConfigEntity;
  }
}
